export enum Authority {
  SUPERADMIN = 'ROLE_SUPERADMIN',
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
}
